<div class="modal-content">
  <div class="section-title apm-text-red text-break">
    {{ 445235 | apmTranslate }}
  </div>

  <div class="scroll-container">
    <div class="mt-2">
      <span>
        <b>{{ workingCondition() }}</b>
      </span>
      <hr class="gray-divider-1 mb-2" />
      <apm-performance-alerts [messages]="messages()"></apm-performance-alerts>
    </div>
    @let _unitConfigErrorCode = unitConfigErrorCode();
    @if (_unitConfigErrorCode) {
      <div class="mt-2">
        <span>
          {{ 451603 | apmTranslate }}:
          <b>{{ unitName() }}</b>
        </span>
        <hr class="gray-divider-1 mb-2" />
        <div class="alert lh-sm d-flex gap-2 align-items-center alert-danger">
          <apm-fa-icon icon="triangle-exclamation" iconSize="sm"></apm-fa-icon>
          <div>{{ configurationErrorCodeResources[_unitConfigErrorCode] | apmTranslate }}</div>
        </div>
      </div>
    }
    @let _externalUnitConfigErrorCode = externalUnitConfigErrorCode();
    @if (_externalUnitConfigErrorCode) {
      <div class="mt-2">
        <span>
          {{ 451603 | apmTranslate }}:
          <b>{{ externalUnitName() }}</b>
        </span>
        <hr class="gray-divider-1 mb-2" />
        <div class="alert lh-sm d-flex gap-2 align-items-center alert-danger">
          <apm-fa-icon icon="triangle-exclamation" iconSize="sm"></apm-fa-icon>
          <div>{{ configurationErrorCodeResources[_externalUnitConfigErrorCode] | apmTranslate }}</div>
        </div>
      </div>
    }
    @for (accessory of accessoriesErrorConfigCodes(); track accessory.code) {
      <div class="mt-2 d-flex flex-column">
        <span>
          {{ 451603 | apmTranslate }}:
          <b>{{ unitName() }}</b>
        </span>
        <span>
          {{ 451604 | apmTranslate }}:
          <b>{{ accessory.code }} - {{ accessory.resourceId | apmTranslate }}</b>
        </span>
        <hr class="gray-divider-1 mb-2" />
        <div class="alert lh-sm d-flex gap-2 align-items-center alert-danger">
          <apm-fa-icon icon="triangle-exclamation" iconSize="sm"></apm-fa-icon>
          <div>{{ configurationErrorCodeResources[accessory.configErrorCode] | apmTranslate }}</div>
        </div>
      </div>
    }
  </div>

  <div class="row justify-content-end mt-4">
    <div class="col-4">
      <apm-button class="w-100 me-3" variant="secondary" (click)="closeDialog()">{{
        '444714' | apmTranslate
      }}</apm-button>
    </div>
  </div>
</div>
